import { useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import { t } from "../data/translations";
import styles from "./Contact.module.css";

const Contact = () => {
  const { lang } = useLang();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    topic: "Website",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`[myapple.gr] ${formData.topic} – ${formData.name}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nTopic: ${formData.topic}\n\n${formData.message}`
    );
    window.location.href = `mailto:info@myapple.gr?subject=${subject}&body=${body}`;
    setFormData({ name: "", email: "", topic: "Website", message: "" });
  };

  return (
    <motion.div
      className={styles.container}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <h2 className={styles.title}>{t("contact.title", lang)}</h2>
      <p className={styles.subtitle}>{t("contact.subtitle", lang)}</p>

      {/* Dual CTA - Meeting Options */}
      <motion.div
        className={styles.meetingSection}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        <h3 className={styles.meetingTitle}>{t("contact.meetingTitle", lang)}</h3>
        <p className={styles.meetingDesc}>{t("contact.meetingDesc", lang)}</p>
        <div className={styles.meetingButtons}>
          <a href="mailto:info@myapple.gr?subject=In-Person%20Meeting" className={styles.meetingBtn}>
            {t("contact.ctaInPerson", lang)}
          </a>
          <a href="mailto:info@myapple.gr?subject=Online%20Meeting" className={styles.meetingBtnOutline}>
            {t("contact.ctaOnline", lang)}
          </a>
        </div>
      </motion.div>

      <div className={styles.divider}>
        <span>{lang === "en" ? "or send us a message" : "ή στείλτε μας μήνυμα"}</span>
      </div>

      <form className={styles.form} onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder={t("contact.nameLabel", lang)}
          value={formData.name}
          onChange={handleChange}
          required
        />

        <input
          type="email"
          name="email"
          placeholder={t("contact.emailLabel", lang)}
          value={formData.email}
          onChange={handleChange}
          required
        />

        <select
          name="topic"
          value={formData.topic}
          onChange={handleChange}
          required
        >
          <option value="Website">{t("contact.topicWebsite", lang)}</option>
          <option value="E-shop">{t("contact.topicEshop", lang)}</option>
          <option value="Marketing">{t("contact.topicMarketing", lang)}</option>
          <option value="Audit">{t("contact.topicAudit", lang)}</option>
          <option value="Other">{t("contact.topicOther", lang)}</option>
        </select>

        <textarea
          name="message"
          rows="5"
          placeholder={t("contact.messageLabel", lang)}
          value={formData.message}
          onChange={handleChange}
          required
        />

        <motion.button
          type="submit"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          {t("contact.sendButton", lang)}
        </motion.button>
      </form>

      <div className={styles.altContact}>
        <p>📧 {t("contact.altEmail", lang)}</p>
        <a href="mailto:info@myapple.gr">info@myapple.gr</a>
      </div>
    </motion.div>
  );
};

export default Contact;
